"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractOption = void 0;
var lodash_1 = require("lodash");
var Contract_1 = require("../Types/Contract");
var ContractOption = /** @class */ (function () {
    function ContractOption(contract) {
        this.contract = contract;
        if (this.contract) {
            if (this.contract.version === 0)
                this.contract = new Contract_1.V0(this.contract);
            else
                throw new Error('contract error');
        }
    }
    ContractOption.read = function (buffer, offset) {
        var isContract = buffer.readUInt8(offset);
        offset++;
        var contract = undefined;
        if (isContract === 1) {
            var _a = Contract_1.ContractFactory.read(buffer, offset), innerContract = _a.contract, tempOffset = _a.offset;
            contract = innerContract;
            offset = tempOffset;
        }
        return { contractOption: new ContractOption(contract), offset: offset };
    };
    ContractOption.prototype.getSize = function () {
        var contractSize = 1;
        if (!lodash_1.isUndefined(this.contract)) {
            contractSize += this.contract.getSize();
        }
        return contractSize;
    };
    ContractOption.prototype.write = function (buffer, offset) {
        if (lodash_1.isUndefined(this.contract)) {
            offset = buffer.writeUInt8(0, offset);
        }
        else {
            offset = buffer.writeUInt8(1, offset);
            offset = this.contract.write(buffer, offset);
        }
        return offset;
    };
    ContractOption.prototype.toJson = function () {
        return {
            contract: this.contract ? this.contract.toJson() : undefined
        };
    };
    return ContractOption;
}());
exports.ContractOption = ContractOption;
//# sourceMappingURL=ContractOption.js.map